import { render, staticRenderFns } from "./pengajuanAdd.vue?vue&type=template&id=0860e79a&scoped=true"
import script from "./pengajuanAdd.vue?vue&type=script&lang=js"
export * from "./pengajuanAdd.vue?vue&type=script&lang=js"
import style0 from "./pengajuanAdd.vue?vue&type=style&index=0&id=0860e79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0860e79a",
  null
  
)

export default component.exports